import { Col, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox } from "stories";
import { mockedItems } from "./constants";
import classes from "./SubAssetType.module.scss";

export const getSubAssetModel = () => ({
  "retail/commercial": {
    "strip mall": [],
    "commercial mall": [],
    "commercial bay": [],
    other: [],
  },
  "residential multi-family": {
    "condominium/apartment": [],
    "row/townhouse": [],
    other: [],
  },
  industrial: {
    warehouse: [],
    "industrial bay": [],
    other: [],
  },
  hospitality: {
    hotel: [],
    resort: [],
    other: [],
  },
  specialty: {
    "student housing": [],
    "retirement facility": [],
    storage: [],
    other: [],
  },
  office: {
    office: [],
  },
  land: {
    "raw land": [],
    "serviced land": [],
  },
});

export const SubAssetType = ({ objKey }) => {
  const form = useFormContext();

  return (
    <Row>
      {mockedItems.sections.map((section) => (
        <Row key={section.id}>
          {section.categoryList.map((category) => (
            <Col xs={6} key={category.name}>
              <div className={classes["section-title"]}>{category.name}</div>
              {category.itemList.map((item) => (
                <Row key={item.id}>
                  <Col xs={3} xxl={2}>
                    <Controller
                      name={`${objKey}.${category.key}.${item.key}`}
                      control={form.control}
                      render={({ field }) => {
                        return (
                          <Checkbox
                            label={"Strata"}
                            checked={(field.value || []).includes("strata")}
                            onChange={() => {
                              let v = [...(field.value || [])];
                              if ((field.value || []).includes("strata"))
                                v = v.filter((item) => item !== "strata");
                              else v.push("strata");
                              field.onChange(v);
                            }}
                          />
                        );
                      }}
                    />
                  </Col>
                  <Col xs={4} xxl={3}>
                    <Controller
                      name={`${objKey}.${category.key}.${item.key}`}
                      control={form.control}
                      render={({ field }) => {
                        return (
                          <Checkbox
                            label={"Non Strata"}
                            checked={(field.value || []).includes("non-strata")}
                            onChange={() => {
                              let v = [...(field.value || [])];
                              if ((field.value || []).includes("non-strata"))
                                v = v.filter((item) => item !== "non-strata");
                              else v.push("non-strata");
                              field.onChange(v);
                            }}
                          />
                        );
                      }}
                    />
                  </Col>
                  <Col>
                    <div className={classes["item-title"]}>{item.title}</div>
                  </Col>
                </Row>
              ))}
            </Col>
          ))}
        </Row>
      ))}
    </Row>
  );
};
